<template>
<div>
  <button @click="sendToGame">Send to game</button>
  <div id="furioosContainer">
    
  </div>
</div>
</template>

<script>
import { Player } from 'furioos-sdk';

export default {
  name: 'furioosPlayer',
  props: {
    msg: String
  },
  data() {
    return {
      player: null,
    }
  },
  mounted() {
    const options = {
        whiteLabel: true,
        hideToolbar: false,
        hideTitle: true,
        hidePlayButton: false,
        debugAppMode: false,
    };

    this.player = new Player("675.188", "furioosContainer", options);

    this.player.onSDKMessage(function (data) {
        console.log("Message received from my application: ", data);
        window.open(data, '_blank');
    });

    this.player.onAppInstallSuccess(function () {
        // Implement your own code.
        console.log("My application is fully installed");
    })

    this.player.onAppStart(function () {
        // Implement your own code.
        console.log("Application started");
    })

    this.player.onStreamStart(function () {
        // Implement your own code.
        console.log("Stream started");
    })
  },
  methods: {
    sendToGame() {      
       this.player.sendSDKMessage({ "test": "test" }); 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
